import { defineComponent as _defineComponent } from 'vue'
import { computed, inject, ref } from 'vue'
import { ModalWrapper } from '@/shared/ui/modals'
import { useEventDeleteMutation } from '@/enitites/event/api/queries'
import { useRoute, useRouter } from 'vue-router/composables'


export default /*#__PURE__*/_defineComponent({
  __name: 'EventEditActionButtons',
  props: {
    isLoading: { type: Boolean },
    disabled: { type: Boolean },
    error: null,
    nextButtonText: null,
    hideCancelButton: { type: Boolean }
  },
  emits: ["next", "back", "cancel"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'next'): void
  (e: 'back'): void
  (e: 'cancel'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  isLoading: boolean
  disabled: boolean
  error?: string
  nextButtonText?: string
  hideCancelButton?: boolean
};

const currentEventStep = inject<number>('currentEventStep', 0)
const totalEventSteps = inject<number>('totalEventSteps', 1)
const isCreationFlow = inject<boolean>('isCreationFlow', false)





const { mutate: deleteEvent, isPending } = useEventDeleteMutation()
const route = useRoute()
const router = useRouter()

const isShowCancelModal = ref(false)

async function removeEvent() {
  if (isPending.value || !route.params.id) return

  deleteEvent(Number(route.params.id), {
    onSuccess: () => {
      router.push({ name: 'EventsGrid' })
    },
  })
}

const computedNextButtonText = computed(() => {
  if (props.nextButtonText) {
    return props.nextButtonText
  }
  return isCreationFlow && currentEventStep + 1 !== totalEventSteps ? 'next' : 'save'
})

return { __sfc: true,currentEventStep, totalEventSteps, isCreationFlow, props, emit, deleteEvent, isPending, route, router, isShowCancelModal, removeEvent, computedNextButtonText, ModalWrapper }
}

})